import { ref } from 'vue';

import { _G } from '@/system_modules/utils/_common';
import moment from 'moment-timezone';

// console.log(moment.utc().format("DD.MM.YYYY HH:mm:ss"));
// console.log(moment.utc(1724745307472).format(), '1724745307472');
// console.log(moment.utc(1724745401511).format(), '1724745401511');
// console.log(moment(1724745401511).format());
// console.log(moment.utc(1724750748611).format(), 'from server');

// console.log(moment.tz('UTC').toISOString());
// console.log( moment().format() );
// console.log( moment.utc().format() );
// console.log( moment.utc(1724745401511).format() );
// console.log( moment.utc(1724745401511).tz("Asia/Baku").format() );

export const G = Object.assign(_G, {
    ajaxBaseUrl: {
        // "default": `http://localhost:8000`,
        "default": `https://backend.okcu.az`,
    },

    ajaxHeaders: {
        'X-Reguest-With': () => {
            // let a = _G.exf9('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789ÜİĞÖƏIŞÇüğöəışç!@#$%^&*()_+=-~`}{|":?></.,\';][');
            // console.log("G", moment.utc());
            let a = _G.exf9(moment.utc().valueOf());
            return btoa(a + '.' + _G.exf9('__34fo34PYT#$p8ap;to34@P(*$#{@)(TWEFS__') + '.' + a);
        },
    },

    mediaURL: `http://localhost:8000/media/`,

    main_host: 'okcu.az',

    // Theme variable value equal Bootstrap colors. Example: ( primary, success, info, warning, danger, dark, light ) or custom.
    // Set your custom color in assets/css/default.css file --bs-custom-rgb variable
    theme: "custom",

    defaultSelectedMenu: "dashboard",
    defaultPage: "pages/dashboard/Dashboard",

    projectLogo: '/assets/images/da_logo.png',
    projectName: `OKCU MMC`,
    projectTitle: `<b class="text-danger">OKCU</b> MMC`,
    projectSubtitle: "Project subtitle info",
    projectInfo: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. <br /> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,

    projectAbout: `Bu proqram DİARC MMC şirkəti tərəfindən hazırlanmışdır. <br /> Proqram Əsas səhifədən və onun elementlərini idarə etməyə imkan verən "İdarəetmə sistemi"-ndən ibarətdir.`, //<br /><br />Bütün müəllif hüquqları Azərbaycan Respublikasının Qanunvericiliyi ilə qorunur.`,

    footerPowered: '© 2025. <a href="https://diarc.az" class="footer-info-link" target="_blank">DIARC.AZ</a> tərəfindən <b>09 İyul 2025</b> tarixində istifadəyə verilmişdir.',
    footerDescription: '',
    footerMenuText: 'Powered by <b class="px-1"><a href="https://diarc.az" class="footer-info-link text-light" target="_blank">DIARC</a></b> ©2025',
    footerMenuMiniText: '<a href="https://diarc.az" class="footer-info-link text-light" target="_blank">DIARC</a>',

    rowsPerPage: 10,
    rowsPerPageOptions: [5, 10, 15, 25, 50, 100],

    // uploadedFileSize: 52428800,
    uploadedFileSize: 10485760, // 10 Mb

    showFilterAfterLength: 15,

    toastLifeTime: 1000,

    // systemData: reactive({"timezone": {"value": "UTC", "type": "text"}}),
    intervalRef: ref(null),
    readWarningIntervalRef: ref(60000),

    warningsListRef: ref([]),

    datetime_format: {
        'pg_datetime': 'YYYY-MM-DD HH:mm:ss',
        'datetime': 'DD.MM.YYYY HH:mm:ss',
        'date': 'DD.MM.YYYY',
        'year': 'YYYY',
        'month': 'MM.YYYY',
        'time': 'HH:mm:ss',
        'hourminute': 'HH:mm',
        'for_file': 'DD.MM.YYYY__HH.mm.ss',
        'for_print': 'DD.MMM.YYYY HH:mm',
        'datetime_as_pg': 'YYYY-MM-DDTHH:mm:ss.SSSZ',
    },

    ignored_routes: [
        "pdf_viewer_letter",
        "pdf_viewer",
        "notfound_full",
        "notfound",
        "notperm",
        "login",
        "profile",
        "404",
        "about",
    ],

    isTheme: (theme) => {
        let themes = [
            'custom',
            'primary',
            'secondary',
            'warning',
            'danger',
            'success',
            'info',
            'dark',
        ];
        return themes.includes(theme);
    },

    getFileMimeType: (file) => {
        let a = '';
        // switch( file.type.split('.').at(-1) ){
        switch( file.name.split('.').at(-1) ){
            // case 'audio/mpeg':
            //     a = '<i class="far fa-file-audio"></i>';
            //     break;
            // case 'video/mp4':
            //     a = '<i class="far fa-file-video"></i>';
            //     break;
            // case 'application/pdf':
            //     a = '<i class="far fa-file-pdf"></i>';
            //     break;
            // case 'application/zip':
            //     a = '<i class="far fa-file-archive"></i>';
            //     break;
            // case 'application/x-x509-ca-cert':
            //     a = '<i class="far fa-file-archive"></i>';
            //     break;
            // case 'application/pkix-cert':
            //     a = '<i class="far fa-file-archive"></i>';
            //     break;
            // case 'text/csv':
            //     a = '<i class="fas fa-file-csv"></i>';
            //     break;
            // case 'text/plain':
            //     a = '<i class="far fa-file-alt"></i>';
            //     break;
            // case 'document':
            //     a = '<i class="far fa-file-word"></i>';
            //     break;
            // case 'sheet':
            //     a = '<i class="far fa-file-excel"></i>';
            //     break;
            // case 'presentation':
            //     a = '<i class="far fa-file-powerpoint"></i>';
            //     break;
            case 'mpeg':
                a = '<i class="far fa-file-audio"></i>';
                break;
            case 'mp3':
                a = '<i class="far fa-file-audio"></i>';
                break;
            case 'mp4':
                a = '<i class="far fa-file-video"></i>';
                break;
            case 'pdf':
                a = '<i class="far fa-file-pdf"></i>';
                break;
            case 'zip':
                a = '<i class="far fa-file-archive"></i>';
                break;
            case 'csv':
                a = '<i class="fas fa-file-csv"></i>';
                break;
            case 'txt':
                a = '<i class="far fa-file-alt"></i>';
                break;
            case 'doc':
                a = '<i class="far fa-file-word"></i>';
                break;
            case 'docx':
                a = '<i class="far fa-file-word"></i>';
                break;
            case 'xls':
                a = '<i class="far fa-file-excel"></i>';
                break;
            case 'xlsx':
                a = '<i class="far fa-file-excel"></i>';
                break;
            case 'ppt':
                a = '<i class="far fa-file-powerpoint"></i>';
                break;
            case 'pptx':
                a = '<i class="far fa-file-powerpoint"></i>';
                break;
            case 'jpg':
                a = '<i class="far fa-image"></i>';
                break;
            case 'jpeg':
                a = '<i class="far fa-image"></i>';
                break;
            case 'png':
                a = '<i class="far fa-image"></i>';
                break;
            default:
                a = '<i class="far fa-file"></i>';
                break;
        }
        return a;
    },

    // cbc_encrypt: (plainText, secret) => {
    //     const CryptoJS = inject('cryptojs');
    //     var key = CryptoJS.enc.Utf8.parse(secret);
    //     let iv = CryptoJS.lib.WordArray.create(key.words.slice(0, 4));
    //     console.log(iv, "IV : " + CryptoJS.enc.Base64.stringify(iv));

    //     // Encrypt the plainText
    //     var cipherText = CryptoJS.AES.encrypt(plainText, key, {
    //       iv: iv,
    //       mode: CryptoJS.mode.CBC,
    //       padding: CryptoJS.pad.Pkcs7
    //       });
    //   return {c: cipherText.toString(), iv: iv};
    // },

    // cbc_decrypt: (cipherText, secret, iv) => {
    //     const CryptoJS = inject('cryptojs');
    //     // IV is a base64 string
    //     let iv1 = CryptoJS.enc.Base64.parse(iv);

    //     var key = CryptoJS.enc.Utf8.parse(secret);
    //     var cipherBytes = CryptoJS.enc.Base64.parse(cipherText);

    //     var decrypted = CryptoJS.AES.decrypt({ciphertext: cipherBytes}, key, {
    //         iv: iv1,
    //         mode: CryptoJS.mode.CBC,
    //         padding: CryptoJS.pad.Pkcs7
    //     });

    //     return decrypted.toString(CryptoJS.enc.Utf8);
    // },

    // RGEXP: new RegExp('.{0,50}<b class="text-warning">[\\s\\S\\;\\(\\)\\|\'\\.]*?<\\/b>.{0,50}', 'mgi'),

    // RGEXP: new RegExp('.{0,50}<enter>[\\s\\S\\n\\r\\t]*?<\\/enter>.{0,50}', 'mgi'),
    RGEXP: new RegExp('.{0,50}<b style="font-weight: bold; color: #e36209;">[\\s\\S\\n\\r\\t]*?<\\/b>.{0,50}', 'mgi'),

    // RGEXP: new RegExp('.{0,50}<b class="text-warning">[\\s\\S\\n\\r\\t]*?<\\/b>.{0,50}', 'mgi'),


    // escapeRegExp: (txt) => {
    //     return txt.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    // },

    matchRGEXP: (txt) => {
        if( txt && txt.length ){
            // let t = G.escapeRegExp(txt);
            let m = txt.match(G.RGEXP);
            if( m && m.length ){
                return m[0];
                // return m[0].replace("<\/enter>", "</b>").replace("<enter>", '<b style="font-weight: bold; color: #e36209;">');
            }
            else
                return G.stripTags(txt).substring(0, 120);
        }
        else
            return txt;
    },

});
